import { graphql, useStaticQuery } from "gatsby"

export interface Translations {
  footer: {
    legal: string;
    language: string;
  }
  nav: {
    contact: string;
  }
}

export const useTranslations: (lang: string) => Translations = (lang: string) => {
  const { messagesYaml } = useStaticQuery(
    graphql`
        query Translations {
            messagesYaml {
                en {
                    nav{
                        contact
                    }
                    footer {
                        legal
                        language
                    }
                }
                de {
                    nav{
                        contact
                    }
                    footer {
                        legal
                        language
                    }
                }
            }
        }
    `
  )

  return messagesYaml[lang]
}
